import { themeClasses, type Theme } from "@cw/design-tokens/theme";
import { ContainedSection, SectionHeader } from "../primitives/Section";
export function StatBand({ heading, items, theme = "ink" }: { heading?: string; items: { value: string; label: string }[]; theme?: Theme }) {
  const t = themeClasses(theme);
  return (
    <ContainedSection theme={theme} compact>
      <SectionHeader heading={heading} theme={theme} />
      <dl className={`grid gap-8 ${items.length >= 4 ? "sm:grid-cols-2 lg:grid-cols-4" : "sm:grid-cols-3"}`}>
        {items.map((s) => (
          <div key={s.label}>
            <dd className={`${t.heading} font-display text-display-md font-semibold tabular-nums`}>{s.value}</dd>
            <dt className={`${t.muted} mt-2 text-sm`}>{s.label}</dt>
          </div>
        ))}
      </dl>
    </ContainedSection>
  );
}
